// extracted by mini-css-extract-plugin
export default {"contentblock":"side-navigation-target-content_contentblock__llv2k","placeHolderShimmer":"side-navigation-target-content_placeHolderShimmer__aZlRA"};